import { Columns } from '#types/grid';

export const columnDefinition: Columns = [
  {
    key: 'item.item_lookup_dialog.grid.columns.item',
    field: 'item',
    width: 140,
    sort: 'asc',
    sortOrder: 1,
  },
  {
    key: 'item.item_lookup_dialog.grid.columns.custid',
    field: 'custid',
    width: 80,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'item.item_lookup_dialog.grid.columns.descr',
    field: 'descr',
    width: 200,
  },
  {
    key: 'item.item_lookup_dialog.grid.columns.abbrev',
    field: 'abbrev',
    width: 120,
  },
  {
    key: 'item.item_lookup_dialog.grid.columns.statusabbrev',
    field: 'statusabbrev',
    width: 70,
  },
  {
    key: 'item.item_lookup_dialog.grid.columns.rategroupabbrev',
    field: 'rategroupabbrev',
    width: 70,
  },
  {
    key: 'item.item_lookup_dialog.grid.columns.baseuomabbrev',
    field: 'baseuomabbrev',
    width: 70,
  },
  {
    key: 'item.item_lookup_dialog.grid.columns.realitem',
    field: 'realitem',
    width: 120,
  },
  {
    key: 'item.item_lookup_dialog.grid.columns.hazardous',
    field: 'hazardous',
    width: 90,
    formatter: 'yn',
  },
  {
    key: 'item.item_lookup_dialog.grid.columns.lastcount',
    field: 'lastcount',
    width: 80,
    type: 'date',
  },
  {
    key: 'item.item_lookup_dialog.grid.columns.productgroup',
    field: 'productgroup',
    width: 85,
  },
  {
    key: 'item.item_lookup_dialog.grid.columns.status',
    field: 'status',
    width: 70,
    visible: false,
  },
  {
    key: 'item.item_lookup_dialog.grid.columns.rategroup',
    field: 'rategroup',
    width: 80,
    visible: false,
  },
  {
    key: 'item.item_lookup_dialog.grid.columns.baseuom',
    field: 'baseuom',
    width: 70,
    visible: false,
  },
  {
    key: 'item.item_lookup_dialog.grid.columns.weight',
    field: 'weight',
    visible: true,
    formatter: 'decimal',
    width: 70,
    align: 'right',
  },

  {
    key: 'item.item_lookup_dialog.grid.columns.weight_kgs',
    field: 'weight_kgs',
    visible: true,
    formatter: 'decimal',
    width: 70,
    align: 'right',
  },

  {
    key: 'item.item_lookup_dialog.grid.columns.lotrequired',
    field: 'lotrequired',
    width: 80,
    visible: true,
    formatter: 'yn',
  },

  {
    key: 'item.item_lookup_dialog.grid.columns.serialrequired',
    field: 'serialrequired',
    width: 80,
    visible: true,
    formatter: 'yn',
  },

  {
    key: 'item.item_lookup_dialog.grid.columns.user1required',
    field: 'user1required',
    width: 80,
    visible: true,
    formatter: 'yn',
  },

  {
    key: 'item.item_lookup_dialog.grid.columns.user2required',
    field: 'user2required',
    width: 80,
    visible: true,
    formatter: 'yn',
  },

  {
    key: 'item.item_lookup_dialog.grid.columns.user3required',
    field: 'user3required',
    width: 80,
    visible: true,
    formatter: 'yn',
  },

  {
    key: 'item.item_lookup_dialog.grid.columns.mfgdaterequired',
    field: 'mfgdaterequired',
    width: 80,
    visible: true,
    formatter: 'yn',
  },

  {
    key: 'item.item_lookup_dialog.grid.columns.expdaterequired',
    field: 'expdaterequired',
    width: 80,
    visible: true,
    formatter: 'yn',
  },

  {
    key: 'item.item_lookup_dialog.grid.columns.countryrequired',
    field: 'countryrequired',
    width: 80,
    visible: true,
    formatter: 'yn',
  },
];
